import { useEffect, useRef } from 'react';
import markup from './customer.html?raw';
import { initCustomer } from './legacy/customer.js';
import Deals from './Deals';
import './styles/deals.css';

// ============================================================================================
// STAGE 1: the copied site, running unchanged inside React.
//
// The markup is injected verbatim and the copied script wires itself to it on mount, exactly as
// it did on the old page. React is not managing any of it yet — that is the point. Nothing has
// been retyped, so nothing can have silently drifted.
//
// STAGE 2 replaces this one piece at a time: results list, then passenger form, then the
// calendar, then the airport pickers. Each one comes out of customer.html + customer.js and
// becomes a real component, and each is testable on its own.
// ============================================================================================
export default function App() {
  const ref = useRef<HTMLDivElement>(null);
  const started = useRef(false);
  // The deals board is its own page at /?deals. Kept a separate view rather than a tab inside
  // the booking flow: it is a different thing for a different visitor, and it must load without
  // the search machinery starting up behind it.
  const onDeals = /[?&]deals\b/.test(window.location.search);

  useEffect(() => {
    if (onDeals) return;           // the booking page's script must not run on the deals board
    if (started.current) return;   // never wire the same DOM twice
    started.current = true;
    // If this throws, every listener after the failure point never attaches and the page looks
    // fine while half its buttons do nothing. Say so on screen instead.
    try {
      initCustomer();
    } catch (err: any) {
      const show = (window as any).__ymShowError;
      if (show) show('Startup failed: ' + (err && err.message ? err.message : String(err)), err && err.stack ? String(err.stack).split('\n')[1] : '');
      else throw err;
    }
  }, [onDeals]);

  if (onDeals) return <Deals />;

  return <div ref={ref} dangerouslySetInnerHTML={{ __html: markup }} />;
}
